var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "directory-list", attrs: { id: "directory-list" } },
    [
      _c(
        "TMSHeader",
        {
          attrs: {
            title: _vm.$t("directory.listTitle", [_vm.tenancyInfo.name]),
            buttons: _vm.buttons,
            needGoback: true,
            goBack: _vm._goback,
            fullScreen: true,
          },
          scopedSlots: _vm._u(
            [
              _vm.histories.length &&
              _vm.isEngineer &&
              _vm.displayReassignButton
                ? {
                    key: "status",
                    fn: function () {
                      return [
                        _c("HKLGrayHint", { staticClass: "under-review-by" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t("underReviewBy", [
                                  _vm.histories[0].detail.value.displayName,
                                ])
                              ) +
                              "\n      "
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [
          _vm.items.length !== 0
            ? _c("HKLSelect", {
                staticClass: "list-filter",
                attrs: {
                  slot: "before-buttons",
                  disabled: false,
                  required: false,
                  options: _vm.filterHklOptions,
                  placeholder: "",
                  showSearch: true,
                  value: _vm.currentFilterIndex,
                },
                on: { change: _vm.selectFilterOption },
                slot: "before-buttons",
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.items.length === 0 && _vm.loading
        ? _c("div", { staticClass: "apply" }, [
            _vm.canCurrUserCreate
              ? _c("p", [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("directory.msg.applyOne")) +
                      "\n    "
                  ),
                ])
              : _c("p", [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("directory.msg.noDir")) +
                      "\n    "
                  ),
                ]),
            _vm._v(" "),
            _vm.canCurrUserCreate
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn--orange margin-top",
                    attrs: { type: "button" },
                    on: { click: _vm.openCreateModal },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.addDirectory")))]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.items.length && _vm.loading
        ? _c(
            "div",
            { staticClass: "items" },
            [
              _c(
                "label",
                { staticClass: "directory-list__sub-title" },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("directory.lobbyDirectory"))),
                  ]),
                  _vm._v(" "),
                  _vm.canCurrUserCreate
                    ? _c("DottedDropdown", { attrs: { id: "lobby-add-dir" } }, [
                        _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "dot-option-btn",
                              on: {
                                click: function () {
                                  return _vm.create(_vm.DIR_TYPE.LOBBY)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("action.addDirectory")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("DirectoryTable", {
                ref: "lobbyDirTb",
                attrs: {
                  items: _vm.lobbyDirectories,
                  originItems: _vm.originLobbyDirectories,
                },
                on: {
                  "update:pendingItems": _vm.onUpdatePendingItems,
                  "refresh:all": _vm.refreshList,
                  "has:dirCheck": function (result) {
                    return _vm.onDirCheck(_vm.DIR_TYPE.LOBBY, result)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "directory-list__sub-title" },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("directory.floorDirectory"))),
                  ]),
                  _vm._v(" "),
                  _vm.canCurrUserCreate
                    ? _c("DottedDropdown", { attrs: { id: "floor-add-dir" } }, [
                        _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "dot-option-btn",
                              on: {
                                click: function () {
                                  return _vm.create(_vm.DIR_TYPE.FLOOR)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("action.addDirectory")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("DirectoryTable", {
                ref: "floorDirTb",
                attrs: {
                  tableType: _vm.DIR_TYPE.FLOOR,
                  items: _vm.floorDirectories,
                  originItems: _vm.originFloorDirectories,
                },
                on: {
                  "update:pendingItems": _vm.onUpdatePendingItems,
                  "refresh:all": _vm.refreshList,
                  "has:dirCheck": function (result) {
                    return _vm.onDirCheck(_vm.DIR_TYPE.FLOOR, result)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.buttons.length && _vm.canCurrUserApprove
        ? _c("DirectoryReassignModal", { ref: "reassignModal" })
        : _vm._e(),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "confirmSubmit",
        attrs: {
          modalId: "confirmSubmit",
          confirmTitle: _vm.$t("directory.msg.confirmSubmit"),
        },
      }),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "confirmNotifyModal",
        attrs: {
          modalId: _vm.tenancyId + "-dir-approval",
          confirmTitle: _vm.$t("directory.msg.confirmNotify"),
        },
      }),
      _vm._v(" "),
      _vm.canCurrUserCreate
        ? _c("CreateDirectoryModal", {
            ref: "createDirectoryModal",
            attrs: { tenancyId: _vm.tenancyId },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }